import  { AxiosResponse } from "axios";
import { useMutation, useQuery } from "react-query";
import { AppDispatch } from "../../store/store";
import { useDispatch } from "react-redux";
import { useMessageToast } from "../../components/Layout/DefaultLayout";
import { api } from "@data-phone/react-resource-server-auth";
import { Did } from "../../interfaces/Did.type";
import { setSmsDids } from "../../store/slices/SmsDids.slice";
import { addDidSlice, deleteDidSlice, setDidsSlice, updateDidSlice } from "../../store/slices/dids.slice";


export const getSmsDids= async () => {
    const response: AxiosResponse = await api.get(
        `${process.env.REACT_APP_SMS_API_URL}/sms/dids`,
    );
    return response.data;
}


export const getDidsByAccountId = async () => {
    const response: AxiosResponse = await api.get(
        `${process.env.REACT_APP_SMS_API_URL}/did`,
    );
    return response.data;
}

export const addDid = async (data: Did) => {
    const response: AxiosResponse = await api.post(
        `${process.env.REACT_APP_SMS_API_URL}/did`,
        data,
    );
    return response.data;
}

export const deleteDid = async (did: string, dispatch: AppDispatch) => {
    const response: AxiosResponse = await api.delete(
        `${process.env.REACT_APP_SMS_API_URL}/did/${did}`,
    );
    dispatch(deleteDidSlice(did));
    return response.data;
}

export const editDid = async (did: string, data: Partial<Did>,dispatch: AppDispatch) => {
    const response: AxiosResponse = await api.put(
        `${process.env.REACT_APP_SMS_API_URL}/did/${did}`,
        data,
    );
    dispatch(updateDidSlice({did: did, data: data}))
    return response.data;
}


export const useGetSmsDids = () => {
    const dispatch: AppDispatch = useDispatch();
    return useQuery(["dids"], () => getSmsDids(), {
        enabled: false,
        onSuccess: (data) => {
            dispatch(setSmsDids(data))
        }
    })
}

export const useGetDidsByAccountId = () => {
    const dispatch: AppDispatch = useDispatch();
    return useQuery(["accountDids"], () => getDidsByAccountId(), {
        enabled: false,
        onSuccess: (data) => {
            dispatch(setDidsSlice(data))
        }
    })
}

export const useAddDid = () => {
    const dispatch: AppDispatch = useDispatch();
    const {messageApi} = useMessageToast()
    return useMutation((data: Did) => addDid(data), {
        onSuccess: (data) => {
            dispatch(addDidSlice(data))
        },
        onError:(err:any)=>{
            messageApi.error(err.response.data.error)
        }
    })
}

export const useEditDid = () => {
    const dispatch: AppDispatch = useDispatch();
    return useMutation((data: {
        did: string,
        data: Partial<Did>
    }) => editDid(data.did, data.data,dispatch), )
}


export const useDeleteDid = () => {
    const dispatch: AppDispatch = useDispatch();
    return useMutation((did: string) => deleteDid(did, dispatch))
}